export const getSpotifyPlaylistId = (url: string) => {
    const match = url.match(/^https:\/\/open\.spotify\.com\/(?:playlist\/|embed\/playlist\/)(\w+)(\?.*)?$/);
    return match ? match[1] : null;
};
